import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { PromptTypes } from 'generated/graphql-types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-add-existing-prompt-view',
    templateUrl: './add-existing-prompt-view.component.html',
    standalone: false
})
export class AddExistingPromptViewComponent {
   @Output() formSubmitted = new EventEmitter<void>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() accountId: number | null;

   @Input() promptTypesToInclude: PromptTypes[] | null;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
